angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateGPController', function( $scope, $rootScope, $stateParams ) {

	$rootScope.getEvent($stateParams.event_id);

	$scope.event_id = $stateParams.event_id;

	$scope.forms = {};
});
